import {postMethod} from '~/api'

async function post(body) {
    return await postMethod('/api/prepareBookSaveOrder', body)
}

export {post}
